export const SET_CONFIG = 'SET_CONFIG';

export function setConfig(config) {
    return { type: SET_CONFIG, config };
}



// WEBPACK FOOTER //
// ./wp-content/themes/gwy/assets/scripts/source/vpm/post-grid/actions/config.js